import { TDataFromStepOne } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const createCalculationDiscount = ({ calculationId, payload }: any): Promise<any> => {
  return API.post(
    `/api/accommodation/calculations/${calculationId}/discountServices`,
    payload,
  ).then(res => res?.data);
};
